import { Routes, Route, Navigate } from 'react-router-dom';
import { useWebSocket } from './hooks/useWebSocket';
import Layout from './components/Layout';
import RequireAuth from './components/RequireAuth';
import Dashboard from './pages/Dashboard';
import Actions from './pages/Actions';
import ActionDetail from './pages/ActionDetail';
import Clients from './pages/Clients';
import ClientDetail from './pages/ClientDetail';
import Executions from './pages/Executions';
import Recordings from './pages/Recordings';
import RecordingDetail from './pages/RecordingDetail';
import Recipes from './pages/Recipes';
import Settings from './pages/Settings';
import Install from './pages/Install';
import Privacy from './pages/Privacy';
import Login from './pages/Login';

// Component that establishes WebSocket connection when authenticated
function AuthenticatedApp() {
  // Connect to WebSocket for real-time updates
  useWebSocket();

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/actions" element={<Actions />} />
        <Route path="/actions/:id" element={<ActionDetail />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/clients/:id" element={<ClientDetail />} />
        <Route path="/executions" element={<Executions />} />
        <Route path="/recordings" element={<Recordings />} />
        <Route path="/recordings/:id" element={<RecordingDetail />} />
        <Route path="/recipes" element={<Recipes />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/install" element={<Install />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route
        path="*"
        element={
          <RequireAuth>
            <AuthenticatedApp />
          </RequireAuth>
        }
      />
    </Routes>
  );
}
